module.exports = __webpack_public_path__ + "static/media/two.ee8516f8.png";